__turbopack_context__.v({
  "after": "buildBreadcrumbs-module-scss-module__72Ovzq__after",
});
